<template>
  <section id="about" class="inner about">
    <div class="container-fluid p-0 fullheight">
      <div class="row g-0 fullheight">
        <!-- About Section Content Start -->
        <div class="col-12 col-xl-8 inner__content">
          <!-- desktop shadow -->
          <div class="desktop-shadow"></div>
          <!-- inner section blocks -->
          <div class="inner__blocks">
            <!-- Section Container - Section Title Start -->
            <div class="inner__container">
              <div class="content-block">
                <span class="section__subtitle">About us</span>
                <h2>Find out more about me. I love coding!.</h2>
                <p class="section__text">
                  I am 17 years old, I studied programming when I was less than 15 years old. The language I am most proficient in is PHP. I studied PHP from the beginning when I started learning, I am bad at CSS or UI/UX related, but I continue to develop programming logic so that the code I produce is of higher quality
                </p>
              </div>
            </div>
            <!-- Section Container - Section Title End -->

            <!-- Section Container - Features Start -->
            <div class="inner__container">
              <div class="content-block grid-block">
                <div class="container-fluid px-4">
                  <div class="row gx-5 align-items-stretch">
                    <!-- feature single item -->
                    <div class="col-12 col-md-4 feature">
                      <div class="feature__item block-rounded-l">
                        <div class="feature__image block-rounded-m">
                          <img
                            src="https://dummyimage.com/500x500/dedede/636363"
                            alt="Marvio Feature Background"
                          />
                          <div class="feature__icon">
                            <img
                              src="https://dummyimage.com/200x140/636363/ffffff"
                              alt="Marvio Feature Icon"
                            />
                          </div>
                        </div>
                        <div class="feature__descr">
                          <span class="feature__subtitle">Friendly</span>
                          <h4 class="feature__title">
                            I'm friendly
                          </h4>
                          <p class="feature__text">
                            I provide problem solutions in several programming communities, I also sometimes teach at my school
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- feature single item -->
                    <div class="col-12 col-md-4 feature">
                      <div class="feature__item block-rounded-l">
                        <div class="feature__image block-rounded-m">
                          <img
                            src="https://dummyimage.com/500x500/dedede/636363"
                            alt="Marvio Feature Background"
                          />
                          <div class="feature__icon">
                            <img
                              src="https://dummyimage.com/200x140/636363/ffffff"
                              alt="Marvio Feature Icon"
                            />
                          </div>
                        </div>
                        <div class="feature__descr">
                          <span class="feature__subtitle">Active</span>
                          <h4 class="feature__title">In competition</h4>
                          <p class="feature__text">
                            I am active in regional level programming competitions and won first place 2 times.
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- feature single item -->
                    <div class="col-12 col-md-4 feature">
                      <div class="feature__item block-rounded-l">
                        <div class="feature__image block-rounded-m">
                          <img
                            src="https://dummyimage.com/500x500/dedede/636363"
                            alt="Marvio Feature Background"
                          />
                          <div class="feature__icon">
                            <img
                              src="https://dummyimage.com/200x140/636363/ffffff"
                              alt="Marvio Feature Icon"
                            />
                          </div>
                        </div>
                        <div class="feature__descr">
                          <span class="feature__subtitle">Hardwork</span>
                          <h4 class="feature__title">In programming</h4>
                          <p class="feature__text">
                            I spend 8 to 12 hours a day studying programming, plus I go to school majoring in Software engineering
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Section Container - Features End -->

            <!-- Section Container - Skillbars Start -->
            <div class="inner__container">
              <div class="content-block">
                <!-- skillbar single item -->
                <div class="show-skillbar">
                  <div class="skillbar" data-percent="90">
                    <span class="skillbar-title">PHP & Laravel framework</span>
                    <p class="skillbar-bar"></p>
                    <span class="skill-bar-percent"></span>
                  </div>
                </div>
                <!-- skillbar single item -->
                <div class="show-skillbar">
                  <div class="skillbar" data-percent="90">
                    <span class="skillbar-title">PHP Pocketmine plugin development</span>
                    <p class="skillbar-bar"></p>
                    <span class="skill-bar-percent"></span>
                  </div>
                </div>
                <!-- skillbar single item -->
                <div class="show-skillbar">
                  <div class="skillbar" data-percent="80">
                    <span class="skillbar-title">JavaScript & VUE framework</span>
                    <p class="skillbar-bar"></p>
                    <span class="skill-bar-percent"></span>
                  </div>
                </div>
                <!-- skillbar single item -->
                <div class="show-skillbar">
                  <div class="skillbar" data-percent="70">
                    <span class="skillbar-title">Java</span>
                    <p class="skillbar-bar"></p>
                    <span class="skill-bar-percent"></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Section Container - Skillbars End -->

            <!-- Section Container - Showreel Start -->
            <div class="inner__container">
              <div class="content-block">
                <div class="fullwidth-container">
                  <div class="showreel showreel-image-1 block-rounded-l">
                    <div class="showreel__button">
                      <!-- video trigger -->
                      <a
                        href="https://vimeo.com/65036292"
                        id="inner-video-trigger"
                        class="inner-video-trigger"
                      >
                        <em></em>
                        <i class="fa-solid fa-play"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Section Container - Showreel End -->
          </div>
        </div>
        <!-- About Section Content End -->

        <!-- About Section Media Start -->
        <div class="col-12 col-xl-4 inner__media">
          <!-- About Section Image Background Start -->
          <div class="image media-image-about"></div>
          <!-- About Section Image Background End -->
        </div>
        <!-- About Section Media End -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutSection",
};
</script>